import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/img/defaultprofile.jpg'


const _hoisted_1 = {
  key: 0,
  class: "box d-flex align-items-center"
}
const _hoisted_2 = { class: "dashboardImage" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  src: _imports_0,
  key: "def"
}
const _hoisted_5 = {
  key: 2,
  class: "changeImage"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera" }, null, -1)
const _hoisted_7 = { class: "dashboardName" }
const _hoisted_8 = { class: "fs-22" }
const _hoisted_9 = { class: "fs-22" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_input = _resolveComponent("file-input")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.profileDash)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.profileDash.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                src: _ctx.profileDash.imageUrl,
                key: "img"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          (!_ctx.$route.params.userIdentifier || _ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                _createVNode(_component_file_input, {
                  class: "hidden",
                  modelValue: _ctx.imageToUpload,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageToUpload) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_6
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.profileDash.name), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Codice referral:",
              text: "Codice referral:"
            }),
            _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.profileDash.referralCode), 1)
          ]),
          ((_ctx.$store.state.isAdmin() || !_ctx.$route.params.userIdentifier))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mt-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openProfileModal && _ctx.openProfileModal(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Modifica profilo e dati per i pagamenti",
                    text: "Modifica profilo e dati per i pagamenti"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}